module.exports = __webpack_public_path__ + "static/media/notifRota.2294bad4.svg";